import { render, staticRenderFns } from "./1V1Course.vue?vue&type=template&id=20d80428&scoped=true"
import script from "./1V1Course.vue?vue&type=script&lang=js"
export * from "./1V1Course.vue?vue&type=script&lang=js"
import style0 from "./1V1Course.vue?vue&type=style&index=0&id=20d80428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d80428",
  null
  
)

export default component.exports